import { render, staticRenderFns } from "./app-header-title.vue?vue&type=template&id=5475cc18&scoped=true&"
import script from "./app-header-title.vue?vue&type=script&lang=js&"
export * from "./app-header-title.vue?vue&type=script&lang=js&"
import style0 from "./app-header-title.vue?vue&type=style&index=0&id=5475cc18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475cc18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbarTitle})
